import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Login from './pages/auth/Login';
import Signup from './pages/auth/SignUp';

function App() {
  return (
    
      <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
    </Router>
    
  );
}

export default App;
